import { render } from "./ActivateCode.vue?vue&type=template&id=89b94922&scoped=true&ts=true"
import script from "./ActivateCode.vue?vue&type=script&lang=ts"
export * from "./ActivateCode.vue?vue&type=script&lang=ts"

import "./ActivateCode.vue?vue&type=style&index=0&id=89b94922&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b94922"]])

export default __exports__